import { render, staticRenderFns } from "./radio-group.vue?vue&type=template&id=e8fce79e&scoped=true&"
import script from "./radio-group.vue?vue&type=script&lang=js&"
export * from "./radio-group.vue?vue&type=script&lang=js&"
import style0 from "./radio-group.vue?vue&type=style&index=0&id=e8fce79e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fce79e",
  null
  
)

export default component.exports